import { LoquixUncertaintyMarker } from './loquix-uncertainty-marker.js';

if (!customElements.get('loquix-uncertainty-marker')) {
  customElements.define('loquix-uncertainty-marker', LoquixUncertaintyMarker);
}
